import { useState } from "react";
import { OrderItemCondition } from "./OrderItemCondition";
import { v4 as uuidv4 } from 'uuid';
import { useModelState } from "@/utils/useModelState";

export function OrderItemConditionComponent({ condition, roomTypes, programTypes, occupantTypes }: OrderItemConditionComponentProps) {

    const id = uuidv4();

    const [,] = useModelState(condition.version);

    const allRoomTypesSelected = condition.selectedRoomTypes.value.length === 0;

    function toggleAllRoomTypes() {
        if (!allRoomTypesSelected) {
            condition.selectedRoomTypes.setValue([]);
        }
    }

    const programsVisible = programTypes && programTypes.length > 0;

    const allProgramTypesSelected = condition.selectedProgramTypes.value.length === 0;

    function toggleAllProgramTypes() {
        if (!allProgramTypesSelected) {
            condition.selectedProgramTypes.setValue([]);
        }
    }

    const occupantsVisible = occupantTypes && occupantTypes.length > 0;

    const allOccupantTypesSelected = condition.selectedOccupantTypes.value.length === 0;

    function toggleAllOccupantTypes() {
        if (!allOccupantTypesSelected) {
            condition.selectedOccupantTypes.setValue([]);
        }
    }

    return (
        <div>
            <label>Item Types</label>
            <div>
                <div className="form-check">
                    <input className="form-check-input" type="checkbox" value="" id={`${id}Rooms`} checked={condition.roomsSelected.value} onChange={() => condition.roomsSelected.setValue(!condition.roomsSelected.value)} />
                    <label className="form-check-label" htmlFor={`${id}Rooms`}>
                        Rooms
                    </label>
                </div>
                {condition.roomsSelected.value && (
                    <div className="ml-2">
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" value="" id={`${id}AllRoomTypes`} checked={allRoomTypesSelected} disabled={allRoomTypesSelected} onChange={() => toggleAllRoomTypes()} />
                            <label className="form-check-label" htmlFor={`${id}AllRoomTypes`}>
                                Any Room
                            </label>
                        </div>
                        {roomTypes.map(roomType =>
                            <div key={roomType.key} className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id={`${id}${roomType.key}`} checked={condition.selectedRoomTypes.value.includes(roomType.key)} onChange={() => condition.selectedRoomTypes.setValue([...condition.selectedRoomTypes.value, roomType.key])} />
                                <label className="form-check-label" htmlFor={`${id}${roomType.key}`}>
                                    {roomType.name}
                                </label>
                            </div>
                        )}
                    </div>
                )}
                {programsVisible && (
                    <>
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" value="" id={`${id}Programs`} checked={condition.programsSelected.value} onChange={() => condition.programsSelected.setValue(!condition.programsSelected.value)} />
                            <label className="form-check-label" htmlFor={`${id}Programs`}>
                                Programs
                            </label>
                        </div>
                        {condition.programsSelected.value && (
                            <div className="ml-2">
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" value="" id={`${id}AllProgramTypes`} checked={allProgramTypesSelected} disabled={allProgramTypesSelected} onChange={() => toggleAllProgramTypes()} />
                                    <label className="form-check-label" htmlFor={`${id}AllProgramTypes`}>
                                        Any Program
                                    </label>
                                </div>
                                {programTypes.map(programType =>
                                    <div key={programType.key} className="form-check">
                                        <input className="form-check-input" type="checkbox" value="" id={`${id}${programType.key}`} checked={condition.selectedProgramTypes.value.includes(programType.key)} onChange={() => condition.selectedProgramTypes.setValue([...condition.selectedProgramTypes.value, programType.key])} />
                                        <label className="form-check-label" htmlFor={`${id}${programType.key}`}>
                                            {programType.name}
                                        </label>
                                    </div>
                                )}
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" value="" id={`${id}HalfDay`} checked={condition.halfDaySelected.value} onChange={() => condition.halfDaySelected.setValue(!condition.halfDaySelected.value)} />
                                    <label className="form-check-label" htmlFor={`${id}HalfDay`}>
                                        Half Day
                                    </label>
                                </div>
                            </div>
                        )}
                    </>
                )}
                {occupantsVisible && (
                    <>
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" value="" id={`${id}Occupants`} checked={condition.occupantsSelected.value} onChange={() => condition.occupantsSelected.setValue(!condition.occupantsSelected.value)} />
                            <label className="form-check-label" htmlFor={`${id}Occupants`}>
                                Occupants
                            </label>
                        </div>
                        {condition.occupantsSelected.value && (
                            <div className="ml-2">
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" value="" id={`${id}AllOccupantTypes`} checked={allOccupantTypesSelected} disabled={allOccupantTypesSelected} onChange={() => toggleAllOccupantTypes()} />
                                    <label className="form-check-label" htmlFor={`${id}AllOccupantTypes`}>
                                        Any Occupant Type
                                    </label>
                                </div>
                                {occupantTypes.map(occupantType =>
                                    <div key={occupantType.key} className="form-check">
                                        <input className="form-check-input" type="checkbox" value="" id={`${id}${occupantType.key}`} checked={condition.selectedOccupantTypes.value.includes(occupantType.key)} onChange={() => condition.selectedOccupantTypes.setValue([...condition.selectedOccupantTypes.value, occupantType.key])} />
                                        <label className="form-check-label" htmlFor={`${id}${occupantType.key}`}>
                                            {occupantType.name}
                                        </label>
                                    </div>
                                )}
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}

export interface OrderItemConditionComponentProps {
    condition: OrderItemCondition.OrderItemCondition;
    roomTypes: { key: string; name: string }[];
    programTypes: { key: string; name: string }[];
    occupantTypes: { key: string; name: string }[];
}